import { forwardRef } from "react";
import { Combobox } from "@headlessui/react";
import classNames from "classnames";
import { Icon } from "@circle-react-shared/Icon";

export interface ChevronDownButtonProps {
  className?: string;
}

export const ChevronDownButton = forwardRef<
  HTMLButtonElement,
  ChevronDownButtonProps
>(({ className }, ref) => (
  <Combobox.Button
    ref={ref}
    className={classNames(
      "text-dark absolute inset-y-0 right-0 flex items-center pr-2 disabled:!cursor-not-allowed disabled:!opacity-40",
      className,
    )}
  >
    <Icon type="20-chevron-down-sm" size={20} />
  </Combobox.Button>
));

ChevronDownButton.displayName = "ChevronDownButton";
